<template>
  <div class="wrapper impressum-page">
    <div class="page-header page-header-small clear-filter">
      <parallax
          class="page-header-image"
          :style="{ backgroundImage: `url(${bgImage})` }"
      />
    </div>
    <div class="features-6">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">
              Impressum / Datenschutz / Allgemeine Geschäfts&shy;bedingungen
            </h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="impressum-block">
              <div class="description">
                <h4 class="info-title">
                  Impressum
                </h4>
                <p>
                  Boigner Digital GmbH

                  <br><br>Kaisersteig 4/2/3
                  <br>A-2380 Perchtoldsdorf
                  <br>E-Mail: <a href="mailto:office@boigner.digital">office@boigner.digital</a>
                  <br>Web: <a href="https://www.boigner.digital">www.boigner.digital</a>
                  <br>UID: ATU76695015
                  <br>Firmenbuch: Fn 552209y
                  <br>Gerichtsstand: Wiener Neustadt
                  <br>Rechtsform: GmbH (Gesellschaft mit beschränkter Haftung)
                  <br>Geschäftsführung: Thomas Boigner
                  <br><br>Informationspflicht lt. §5 E-Commerce Gesetz, §14 Unternehmensgesetzbuch bzw. §63 Gewerbeordnung und Offenlegungspflicht lt. §25 Mediengesetz
                  <br><br>Copyright Boigner Digital GmbH.
                  <br>Die Verwendung, Vervielfältigung, Reproduktion, Verbreitung oder der Vertrieb der hier veröffentlichten Texte, Grafiken und Inhalte – egal ob teilweise oder zur Gänze – erfordert eine ausdrückliche schriftliche Zustimmung durch den Inhaber dieser Site.
                  <br>Der Inhaber dieser Seite übernimmt keine Verantwortung für die Inhalte anderer Homepages, die auf diesen Seiten verlinkt sind.  </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="impressum-block">
              <div class="description">
                <h4 class="info-title">
                  Allgemeine Geschäftsbedingungen
                </h4>
                <p>
                  Unsere aktuell gültigen AGB finden Sie hier:
                  <br>
                  <a href="https://boigner.digital/AGB.pdf" target="_blank" @click.prevent="redirect">boigner.digital/AGB.pdf</a></p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="impressum-block">
              <div class="description">
                <h4 class="info-title">
                  Datenschutz
                </h4>
                <p>
                  1. Rechtsgrundlage
                  <br>Die EU-Datenschutz-Grundverordnung, das Datenschutzgesetz 2000 sowie das Datenschutz-Anpassungsgesetz 2018 dienen dem Recht auf Schutz personenbezogener Daten. Wir verarbeiten Ihre Daten ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, DSG 2018, TKG 2003).
                  <br>2. Grundsätzliches
                  <br>2.1. Verantwortlicher ist Boigner Digital GmbH, A-2380 Perchtoldsdorf, Kaisersteig 4/2/3
                  <br>2.2. Vertreter des Verantwortlichen ist Thomas Boigner, office@boigner.digital
                  <br>2.3. Uns ist es ein besonderes Anliegen, alle personenbezogenen Daten, die Sie uns anvertrauen, zu schützen und sicher zu verwahren. In diesem Dokument erfahren Sie mehr darüber, wie wir Ihre personenbezogenen Daten verwenden und verarbeiten.

                  <br><br>3. Zweckbindung, Rechtsgrundlage, Speicherdauer sowie Datenempfänger
                  <br>3.1. Die gesammelten personenbezogenen Daten benötigen wir für die Vertragserfüllung, Verrechnung, Geltendmachung der Vertragsansprüche, für Zwecke des Kundenservice und für Werbezwecke. Die Daten werden hierfür erhoben, gespeichert, verarbeitet und genutzt.
                  <br>3.2. Die rechtlichen Grundlagen für die Verarbeitung von Ihren personenbezogenen Daten sind einerseits Vertragserfüllung, berechtigte Interessen, die Erfüllung unserer rechtlichen bzw. vertraglichen Verpflichtungen sowie andererseits Ihre Einwilligung (z.B. Kontaktformular, Newsletter, Cookies). Die Nichtbereitstellung der Daten kann unterschiedliche Folgen haben.
                  <br>3.3. Zudem verarbeiten wir Daten, die wir von Serviceprovidern (Telefondienstleistern, Softwareanbietern, Cloudanbietern) zulässigerweise erhalten haben. Dabei handelt es sich um grundlegende personenbezogene Daten wie z.B.: Ihren Namen, Ihre berufliche Position, Ihr Geburtsdatum sowie Ihre bevorzugten Kontaktangaben (E-Mail-Adresse, Adresse, Telefonnummer, etc). Diese stammen aus öffentlich zugänglichen Quellen (z.B. Telefonbuch) und auch von anbieterseitigen Informationsquellen (z.B. Kundenkartei des Providers).
                  <br>3.4. Wir verarbeiten Ihre personenbezogenen Daten (Name, Adresse, Email, Geburtsdatum), soweit erforderlich, für die Dauer der gesamten Geschäftsbeziehung (von der Anbahnung, Abwicklung bis zur Beendigung eines Vertrags), darüber hinaus gemäß den gesetzlichen Aufbewahrungs- und Dokumentationspflichten, die sich u.a. aus dem Unternehmensgesetzbuch (UGB), der Bundesabgabenordnung (BAO) ergeben, sowie bis zur Beendigung eines allfälligen Rechtsstreits, fortlaufender Gewährleistungs- und Garantiefristen, usw.
                  <br>3.5. Im Rahmen unserer Aufträge beauftragen wir z.B. Softwaredienstleister und Agenturen, als auch Partnerunternehmen, die im Zuge ihrer Tätigkeiten Zugriff auf Ihre personenbezogenen Daten erlangen können, sofern diese die Daten zur Erfüllung ihrer jeweiligen Leistung benötigen. Diese haben sich zur Einhaltung der geltenden datenschutzrechtlichen Bestimmungen uns gegenüber verpflichtet. Es wurden Auftragsverarbeitungsverträge gemäß Art 28 DSGVO abgeschlossen. Nähere Informationen zu den von uns beauftragten Auftragsverarbeitern können Sie unter office@boigner.digital anfragen.

                  <br><br>4. Kontaktformular
                  <br>4.1. Ihre Angaben inklusive persönlicher Daten aus unserem Kontaktformular werden zur Bearbeitung Ihrer Anfrage über unseren eigenen Mailserver an uns übermittelt, weiterverarbeitet und bei uns gespeichert. Diese Daten werden ohne Ihre Einverständniserklärung nicht erhoben oder weitergegeben. Ohne diese Daten können wir Ihre Anfragen nicht bearbeiten.
                  <br>4.2. Die Datenverarbeitung erfolgt auf Basis der gesetzlichen Bestimmungen des § 96 Abs 3 TKG sowie des Art 6 Abs 1 lit a (Einwilligung) DSGVO.

                  <br><br>5. Einwilligung und Recht auf Widerruf
                  <br>5.1. Ist für die Verarbeitung Ihrer Daten Ihre Zustimmung notwendig, verarbeiten wir diese erst nach Ihrer ausdrücklichen Zustimmung.
                  <br>5.2. Grundsätzlich verarbeiten wir keine Daten minderjähriger Personen und sind dazu auch nicht befugt. Mit der Abgabe Ihrer Zustimmung bestätigen Sie, dass Sie das 14. Lebensjahr vollendet haben oder die Zustimmung Ihres gesetzlichen Vertreters vorliegt.
                  <br>5.3. Ihre Zustimmung können Sie jederzeit unter folgender E-Mail-Adresse widerrufen: office@boigner.digital. In einem solchen Fall werden die bisher über Sie gespeicherten Daten anonymisiert und in weiterer Folge lediglich für statistische Zwecke ohne Personenbezug weiterverwendet. Mittels des Widerrufs der Zustimmung wird die Rechtmäßigkeit der aufgrund der Zustimmung bis zum Widerruf erfolgten Verarbeitung nicht berührt.

                  <br><br>6. Datensicherheit
                  <br>6.1. Die Boigner Digital GmbH setzt technische und organisatorische Sicherheitsmaßnahmen ein, um die gespeicherten personenbezogenen Daten gegen zufällige oder vorsätzliche Manipulation, Verlust oder Zerstörung und gegen den Zugriff unberechtigter Personen zu schützen. Unsere Sicherheitsmaßnahmen werden entsprechend des technischen Fortschritts fortlaufend verbessert.

                  <br><br>7. Ihre Rechte
                  <br>7.1. Sie haben jederzeit das Recht auf Auskunft seitens des Verantwortlichen Thomas Boigner, office@boigner.digital über die betreffenden personenbezogenen Daten. Soweit keine gesetzliche Aufbewahrungspflicht besteht, haben Sie das Recht auf Löschung dieser Daten sowie auf Widerspruch gegen die Verarbeitung. Ferner haben Sie das Recht auf Berichtigung der Daten sowie auf Einschränkung der Verarbeitung, auf Datenübertragbarkeit sowie auf Beschwerde bei der Österreichischen Datenschutzbehörde (Wickenburggasse 8-10, 1080 Wien, E-Mail: dsb@dsb.gv.at).
                  <br>7.2. Wenden Sie sich bezüglich Ihrer Rechte bitte an uns unter office@boigner.digital oder schreiben Sie an:
                  <br>Boigner Digital GmbH
                  <br>Kaisersteig 4/2/3
                  <br>A-2380 Perchtoldsdorf
                  <br>Verantwortlicher: Thomas Boigner (office@boigner.digital)</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Impressum',
  bodyClass: 'impressum-page',
  data() {
    return {
      bgImage: require('@/assets/img/bg24.jpg'),
      redirecting: false
    }
  },
  methods: {
    async redirect() {
      const espoClient = this.useEspoClient();

      try {
        this.redirecting = true;
        const response = await espoClient.get('redirect/bdagb');
        this.redirecting = false;
        
        if (response?.url) {
          window.open(response.url, '_blank');
        }
      } 
      catch {
        // Fail silently.
      }
      finally {
        this.redirecting = false;
      }
    }
  }
}
</script>
